import { render } from "./products-page.vue?vue&type=template&id=73e40873&scoped=true"
import script from "./products-page.vue?vue&type=script&lang=js"
export * from "./products-page.vue?vue&type=script&lang=js"

import "./products-page.vue?vue&type=style&index=0&id=73e40873&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e40873"]])

export default __exports__